var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSandbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.115,
    height: 35.25,
    viewBox: "0 0 118.115 35.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1228f3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sandbox",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99230",
    "data-name": "Path 99230",
    className: "cls-1",
    d: "M220.688,15.615h1.772v-.441l-.446-.445h-2.209l-.445.445v3.535l.445.441h2.209l.446-.441v-.441h-1.772v-.885h1.772V16.5h-1.772Z",
    transform: "translate(-160.475 -10.775)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16606",
    "data-name": "Rectangle 16606",
    className: "cls-1",
    width: 2.5,
    height: 2.5,
    transform: "translate(59.185 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99231",
    "data-name": "Path 99231",
    className: "cls-1",
    d: "M204.445,14.725V16.5h-1.327V14.725h-.882l-.444.444V18.7l.444.441h.882V17.377h1.327v1.768h.886l.441-.441V15.169l-.441-.444Z",
    transform: "translate(-147.622 -10.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99232",
    "data-name": "Path 99232",
    className: "cls-1",
    d: "M184.662,14.725l-.444.444v.441h1.327V18.7l.445.441h.441l.441-.441V15.61H188.2v-.441l-.441-.444Z",
    transform: "translate(-134.766 -10.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99233",
    "data-name": "Path 99233",
    className: "cls-1",
    d: "M0,38.644V45.72l1.768,1.768H8.844v3.535H5.307V49.256H0V52.8l1.768,1.768H12.383L14.151,52.8V45.72l-1.768-1.772H5.307V40.414H8.844v1.768H14.15V38.646l-1.768-1.772-10.614,0Z",
    transform: "translate(0 -26.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99234",
    "data-name": "Path 99234",
    className: "cls-1",
    d: "M184.5,36.873v17.69h12.382l1.768-1.768V38.645l-1.768-1.768H184.5Zm5.307,3.54h3.54V51.028H189.8Z",
    transform: "translate(-134.969 -26.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99235",
    "data-name": "Path 99235",
    className: "cls-1",
    d: "M243.8,36.873v17.69h12.382l1.768-1.768V47.488l-1.768-1.767,1.768-1.768V38.646l-1.768-1.768H243.8ZM249.1,47.488h3.54v3.54H249.1Zm0-7.075h3.54v3.535H249.1Z",
    transform: "translate(-178.351 -26.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99236",
    "data-name": "Path 99236",
    className: "cls-1",
    d: "M304.878,36.873l-1.768,1.768v14.15l1.768,1.768h10.61l1.767-1.768V38.641l-1.767-1.768Zm3.535,3.54h3.54V51.028h-3.54Z",
    transform: "translate(-221.742 -26.974)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16607",
    "data-name": "Rectangle 16607",
    className: "cls-1",
    width: 4.725,
    height: 4.725,
    transform: "translate(111.433 18.745) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16608",
    "data-name": "Rectangle 16608",
    className: "cls-1",
    width: 4.725,
    height: 4.725,
    transform: "translate(19.455 31.911) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99237",
    "data-name": "Path 99237",
    className: "cls-1",
    d: "M371.253,36.873V42.18l-1.768,1.768-1.767-1.768V36.873h-3.54l-1.768,1.772v5.3l1.768,1.772-1.768,1.768V52.8l1.768,1.768h3.54V49.257l1.767-1.768,1.768,1.768v5.307h3.54L376.56,52.8V47.488l-1.767-1.768,1.767-1.772v-5.3l-1.767-1.772Z",
    transform: "translate(-265.123 -26.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99238",
    "data-name": "Path 99238",
    className: "cls-1",
    d: "M129.224,36.873V42.18l-5.307-5.307h-3.535l-1.768,1.772V52.8l1.768,1.768h3.535V43.948l5.307,5.307v5.307h3.54l1.768-1.768V38.643l-1.768-1.77Z",
    transform: "translate(-86.773 -26.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99239",
    "data-name": "Path 99239",
    className: "cls-1",
    d: "M71.692,37.022H61.081L59.313,38.79V52.941l1.768,1.768h3.54V47.634h3.535v7.079h3.535l1.768-1.768V38.793Zm-5.307,7.724-2.261-2.259,2.261-2.261,2.261,2.261Z",
    transform: "translate(-43.391 -27.083)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.095d8d05e0d0f290b2ef2efe7e868c79.svg";
export { ForwardRef as ReactComponent };